export enum OrderMode {
    ENQUIRY = 'ENQUIRY',
    DIRECT_ORDER = 'DIRECT_ORDER',
}
